import React from 'react';
import { PriceAlert } from '../components/PriceAlert';
import { Hero } from '../components/Hero';
import { Testimonial } from '../components/Testimonial';
import { ProblemSolution } from '../components/ProblemSolution';
import { ValueStack } from '../components/ValueStack';
import { ModuleBreakdown } from '../components/ModuleBreakdown';
import { Guarantee } from '../components/Guarantee';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-navy font-body text-white" data-id="element-1299">
      <PriceAlert data-id="element-1300" />
      <Hero data-id="element-1301" />
      <Testimonial data-id="element-1302" />
      <ProblemSolution data-id="element-1303" />
      <ValueStack data-id="element-1304" />
      <ModuleBreakdown data-id="element-1305" />
      <Guarantee data-id="element-1306" />
      <PricingSection data-id="element-1307" />
      <Footer data-id="element-1308" />
      <RecentPurchaseToast data-id="element-1309" />
    </div>;
}